import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Doctors = () => {
  return (
    <Box>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Doctors
        </Typography>
        <Typography variant="body1">
          Doctor directory coming soon...
        </Typography>
      </Container>
    </Box>
  );
};

export default Doctors;
